import React, { useState } from 'react'

export default function InternalDashboards() {
  const [loading, setLoading] = useState(true);
  return (
    <>


      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          {loading ? <h1 className="h2"><i class="fa-solid fa-spinner fa-spin"></i></h1> : <h1 className="h2">Company Assets Dashboards</h1>}

        </div>
        <div>

          <iframe
            // src='https://lookerstudio.google.com/reporting/828a352b-10c2-4ebe-b5a4-0921bea97920/page/p_x71xs87nfd'
            src="https://lookerstudio.google.com/embed/reporting/828a352b-10c2-4ebe-b5a4-0921bea97920/page/p_x71xs87nfd"
            onLoad={() => setLoading(false)}
            width={'1225'}
            height={'1000'}
            style={{ display: loading ? 'none' : 'block' }}
            allowfullscreen
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe>
        </div>
      </main>
    </>
  )
}
